import { Component, Inject, OnInit, NgZone } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { DataOrderService } from 'app/shared/services/data-order.service';
import { AlertService } from 'app/shared/services/alert/alert.service';

export interface CancelOrderDialogData {
  refundAmount: string;
  orderid: number;
  currentStatus: string;
  toStatus: string;
  isRejectOrder: boolean;
  headerText?: string | null;
  /** When true, pre-checks the refund checkbox */
  initialRefund?: boolean;
  /**
   * When true, HE-order refunds are handled via _changeOrderStatus({ refund: true })
   * instead of initiateRefund(), avoiding a separate refund API call.
   */
  useRefundFlag?: boolean;
}

@Component({
    selector: 'app-dialog-cancel-order',
    templateUrl: './dialog-cancel-order.component.html',
    styleUrls: ['./dialog-cancel-order.component.scss'],
    standalone: false
})

export class DialogCancelOrderComponent implements OnInit {
  cancellationReason = new UntypedFormControl('', [Validators.required]);
  otherCancellationReason = new UntypedFormControl('', [Validators.required]);
  isRefundOrder = new UntypedFormControl(false);
  loading: boolean = false;
  constructor(public dialogRef: MatDialogRef<DialogCancelOrderComponent>,
    private ngZone: NgZone, @Inject(MAT_DIALOG_DATA) public data: CancelOrderDialogData,
    private orderService: DataOrderService,
    private alertService: AlertService,
    public jwtAuth: JwtAuthService) {
  }

  ngOnInit(): void {
    if (this.data.initialRefund) {
      this.isRefundOrder.setValue(true);
    }
  }

  onNoClick() {
    this.ngZone.run(() => {
      this.dialogRef.close()
    });
  }

  onCancelOrder() {
    if (this.isRefundOrder.value && this.data.useRefundFlag) {
      // Use changeOrderStatus with refund flag instead of initiating a separate refund API call
      this.cancelOrderWithRefundFlag();
    } else if (this.isRefundOrder.value) {
      this.refundOrder();
    } else {
      this.cancelOrder();
    }
  }

  canEnableCancelOrderButton() {
    return this.loading || (this.cancellationReason.value === 'Others' ? !this.otherCancellationReason.value.trim() : !this.cancellationReason.value);
  }

  getCancellationReason() {
    return this.cancellationReason.value === 'Others' ? this.otherCancellationReason.value : this.cancellationReason.value;
  }

  refundOrder() {
    this.loading = true
    let data = {
      amount: this.data.refundAmount,
      remarks: this.getCancellationReason(),
      orderid: this.data.orderid
    }
    if (this.isRefundOrder.value) {
      data['endStatus'] = 'Cancelled'
    }
    this.orderService.initiateRefund(data).subscribe(res => {
      this.alertService.notifySuccess('Refund Successful');
      this.loading = false;
      this.dialogRef.close(1);
    }, err => {
      this.alertService.notifyError(err.error?.msg || 'Refund Unsuccessful');
      this.loading = false;
    });
  }

  cancelOrderWithRefundFlag() {
    this.loading = true;
    this.orderService._changeOrderStatus(
      this.data.orderid, this.data.currentStatus, this.data.toStatus,
      this.getCancellationReason(), { refund: true }
    ).subscribe(res => {
      this.alertService.notifySuccess(res.msg || 'Order cancelled with refund.');
      this.loading = false;
      this.dialogRef.close(1);
    }, err => {
      this.alertService.notifyError(err.error?.msg || 'Failed to cancel order.');
      this.loading = false;
    });
  }

  cancelOrder() {
    this.loading = true
    this.orderService._changeOrderStatus(this.data.orderid, this.data.currentStatus, this.data.toStatus, this.getCancellationReason()).subscribe(res => {
      this.alertService.notifySuccess(res.msg);
      this.loading = false;
      this.dialogRef.close(1);
    }, err => {
      this.alertService.notifyError(err.error?.msg || 'An unexpected error occurred.');
      this.loading = false;
    });
  }
}



